// extracted by mini-css-extract-plugin
export var body = "_cv-0";
export var sectionHeader = "_cv-4";
export var shortcutColumns = "_cv-2";
export var shortcutList = "_cv-1";
export var shortcutSection = "_cv-3";